import { render, staticRenderFns } from "./BookingTasks.vue?vue&type=template&id=3c98751f"
import script from "./BookingTasks.vue?vue&type=script&lang=js"
export * from "./BookingTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports